"use strict";

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if (this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if (this.collection_style == 'slider') {
      this.createSlider();
    }
  },
  createSlider: function createSlider() {
    var featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');
    var slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    };
    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      // 'left' so the first product lines up with the left edge of the section,
      // matching the category tiles above it. Centring left a half-column of
      // empty space at the start of the row.
      cellAlign: 'left',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function ready() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on('settle.flickity', function () {
            $(featuredCollectionSlider).flickity('resize');
          });
        }
      }
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};